import React from 'react';
import { LockIcon } from 'lucide-react';
export function SecuritySection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2819">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-8" data-id="element-2820">
        <div className="flex items-center gap-3 mb-4" data-id="element-2821">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          backgroundColor: 'rgba(30,61,47,0.08)'
        }} data-id="element-2822">
            <LockIcon size={20} style={{
            color: '#1e3d2f'
          }} data-id="element-2823" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2824">
            Security
          </h2>
        </div>
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2825">
          <div className="space-y-4" data-id="element-2826">
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2827">
              We take precautions to protect your information. When you submit
              sensitive information via the website, your information is
              protected both online and offline.
            </p>
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2828">
              Wherever we collect sensitive information (such as credit card
              data), that information is encrypted and transmitted to us in a
              secure way. You can verify this by looking for a lock icon in the
              address bar and looking for "https" at the beginning of the
              address of the Web page.
            </p>
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2829">
              While we use encryption to protect sensitive information
              transmitted online, we also protect your information offline. Only
              employees who need the information to perform a specific job (for
              example, billing or customer service) are granted access to
              personally identifiable information. The computers/servers in
              which we store personally identifiable information are kept in a
              secure environment.
            </p>
          </div>
        </div>
      </div>
    </div>;
}